import { NextPageContext } from "next"
import React from "react"

import { GetInitialPropsType } from "~/api"

const getPage = (
  getInitialProps: GetInitialPropsType,
  Component: React.ComponentType,
): React.ComponentType => {
  return class Page extends React.Component {
    static async getInitialProps(ctx: NextPageContext) {
      return getInitialProps(ctx)
    }

    render(): React.ReactNode {
      return <Component />
    }
  }
}

export default getPage
